import React from 'react'
import { useStateValue } from '@State'
import PropTypes from 'prop-types'
import { Indicator } from '@CommonComponents'

export const Assessment = props => {
  const [currentState, dispatch] = useStateValue()
  const selectDeselectActs = (actArray, act) => {
    if (actArray.map(elem => elem.actPk).includes(act.actPk)) {
      actArray = actArray.filter(elem => elem.actPk !== act.actPk)
    } else {
      actArray.push(act)
    }
    return actArray
  }

  const handleChange = (actPk, canvasId) => {
    let actData = {
      actPk,
      canvasId,
    }
    let newActArray = selectDeselectActs(
      currentState.selectedAssessments,
      actData
    )
    dispatch({ type: 'assessmentInclusion', payload: newActArray })
  }
  return (
    <div className="d-flex align-items-center" key={props.actPk}>
      <Indicator display={props.inCanvas} />
      <input
        className="ml-1"
        type="checkbox"
        disabled={currentState.linksPosting || currentState.linksPosted}
        checked={currentState.selectedAssessments
          .map(elem => elem.actPk)
          .includes(props.actPk)}
        onChange={() => handleChange(props.actPk, props.canvasId)}
      />{' '}
      <span className="ml-2">{props.title}</span>
    </div>
  )
}

Assessment.propTypes = {
  selected: PropTypes.bool,
  title: PropTypes.string,
  actPk: PropTypes.string,
  groupPk: PropTypes.string,
  inCanvas: PropTypes.bool,
  canvasId: PropTypes.string,
}
